import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const cvvInputStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.tiny,
  } as CSSProperties,

  label: {
    display: 'block',
    fontFamily: theme.typography.fontFamily,
    color: theme.colors.label,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.sm,
    letterSpacing: 'normal',
    margin: 0,
  } as CSSProperties,

  input: {
    maxWidth: 264,
    width: '100%',
    padding: `${theme.spacing.mediumSmall}px ${theme.spacing.small}px`,
    height: 36,
    boxSizing: 'border-box',
    // Longhand (no `border`): el modificador de foco/error pisa `borderColor` sin mezclar propiedades.
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.colors.inputBorder,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.inputBg,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.base,
    color: theme.colors.inputText,
    outline: 'none',
  } as CSSProperties,

  inputPlaceholder: {
    color: theme.colors.placeholder,
  } as CSSProperties,

  inputFocus: {
    outline: 'none',
    borderColor: theme.colors.button.primary,
    boxShadow: `0 0 0 2px ${theme.colors.palette.blue160}`,
  } as CSSProperties,

  inputError: {
    borderColor: theme.colors.error,
  } as CSSProperties,

  errorMessage: {
    color: theme.colors.error,
    fontSize: theme.typography.fontSize.xs,
    fontFamily: theme.typography.fontFamily,
    marginTop: theme.spacing.tiny,
  } as CSSProperties,
};
